const entryFragment = `
  testimonialOccupation
  testimonialQuote
  testimonialImage {
    url @transform(mode: "crop", width: 530, height: 668, immediately: true)
    title
    hasFocalPoint
    focalPoint
  }
  testimonialVideo {
    url
    title
    embeddedAsset {
      url
      title
    }
  }
  testimonialVideoOrientation
  testimonialBackgroundVideo {
    id
    url
    title
    embeddedAsset {
      title
      url
      providerName
    }
  }
  testimonialMobileBackgroundVideo {
    id
    url
    title
    embeddedAsset {
      title
      url
      providerName
    }
  }
`

const blockFragment = `
  id
  typeHandle
  idName
  layout
  hideReadMoreButton
  testimonial {
    id
    title
    uri
    typeHandle
    ... on testimonials_Entry {
      ${entryFragment}
    }
    ... on testimonialPages_Entry {
      ${entryFragment}
    }
  }
`

export const CSplitTestimonialFragments = {
  field: `
    fragment splitTestimonial on splitTestimonial_MatrixField {
      ... on splitTestimonial_block_Entry {
        ${blockFragment}
      }
    }
  `,
  field2: `
    fragment splitTestimonial2 on splitTestimonial2_MatrixField {
      ... on splitTestimonial2_block_Entry {
        ${blockFragment}
      }
    }
  `,
}
